import {gsap} from "gsap";
import App from "../../../templates/src/App/App";

const FormResult = {

    hide(button){
        const result = button.closest('.result');
        gsap.to(result, {display:'none', opacity: 0, clearProps:true});
        result.find('.message').removeClass('visible');
    },

    show(result, form, message) {
        if(App.debug) console.log('FormResult.show() ->', result, form, message);
        if(!form.length) return;

        const el = form.find('.result');
        const resultEl = el.find('.' + result);
        const messageEl = el.find('.message');
        const closeBtn =  el.find('.close');

        gsap.set(el, {display:'flex', opacity: 1});
        messageEl.removeClass('visible');
        resultEl.addClass('visible');
        if(message) resultEl.find('p').text(message);

        closeBtn.click((evt)=>{
            this.hide($(evt.currentTarget));
        })
    },
}

export default FormResult